export enum TermStepTranslatorEnum {
  CANCELED = "Cancelado",
  DONE = "Concluído",
  MEMBER_SIGNED = "Aguardando Assinatura",
  OPTIONAL_SIGNATURES_COLLECTED = "Assinaturas aprovadas",
  REJECTED = "Rejeitado",
  REGISTER_CORRECTION = "Correção de Registro",
  TIMED_OUT = "Cancelado por inatividade"
}
